import { action, makeObservable, observable } from 'mobx';
import {
    IAssetAssignmentsList,
    ICardSetManageCardSetsOptions,
    ICardSetManageChecks,
    ICardSetOwnerCompany,
    ISelectList,
} from '../interfaces';

const emptyAssignmentsList: IAssetAssignmentsList = { list: [], total: 0, pageNumber: 1, isLoaded: false };
const emptyChecks: ICardSetManageChecks = {
    childrenCount: 0,
    cardsCount: 0,
    assignedCompaniesCount: 0,
};

export class CardSetManageStore {
    private constructor() {
        makeObservable(this);
    }

    private static instance: CardSetManageStore;
    public static getInstance(): CardSetManageStore {
        if (!CardSetManageStore.instance) {
            CardSetManageStore.instance = new CardSetManageStore();
        }
        return CardSetManageStore.instance;
    }

    @observable ownerCompanies: ICardSetOwnerCompany[] = [];
    @action setOwnerCompanies(list: ICardSetOwnerCompany[]): void {
        this.ownerCompanies = list;
    }

    @observable checks: ICardSetManageChecks = emptyChecks;
    @action setChecks(checks: ICardSetManageChecks): void {
        this.checks = checks;
    }

    @observable futureAssignments: IAssetAssignmentsList = emptyAssignmentsList;
    @action setFutureAssignments(list: IAssetAssignmentsList): void {
        this.futureAssignments = list;
    }

    @observable parentAssignments: IAssetAssignmentsList = emptyAssignmentsList;
    @action setParentAssignments(list: IAssetAssignmentsList): void {
        this.parentAssignments = list;
    }

    @observable childrenSelect: ISelectList = [];
    @action setChildrenSelect(list: ISelectList): void {
        this.childrenSelect = list;
    }

    @observable cardSetsOptions: ICardSetManageCardSetsOptions = {};
    @action setCardSetsOptions(companyId: string, list: ISelectList): void {
        this.cardSetsOptions = { ...this.cardSetsOptions, [companyId]: list };
    }

    @action cleanAssignments(): void {
        this.futureAssignments = emptyAssignmentsList;
        this.parentAssignments = emptyAssignmentsList;
    }

    @action cleanStore(): void {
        this.ownerCompanies = [];
        this.checks = emptyChecks;
        this.futureAssignments = emptyAssignmentsList;
        this.parentAssignments = emptyAssignmentsList;
        this.childrenSelect = [];
        this.cardSetsOptions = {};
    }
}
